import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Array
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface DropdownControllerTargetLifecycleHooks {
  public fun menuTargetConnected(element: HTMLElement) {
  }

  public fun menuTargetDisconnected(element: HTMLElement) {
  }
}

public fun <T : HTMLElement> DropdownController.menuTarget(): StimulusProperty<T> =
    StimulusProperty("menuTarget")

public fun <T : HTMLElement> DropdownController.menuTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("menuTargets")

public fun registerDropdownController(stimulus: Application) {
   val clazz = DropdownController::class
   val properties = object  {
      // Js name needed otherwise Kotlin will mangle the name
      @JsName("targets")
      val targets = js("['menu']")

      @JsName("values")
      val values = buildValues(
          setOf(
              
          ),
          null
      )
      
      
      
      @JsName("classes")
      val classes = js("[]")
  }

  val factoryFunc = clazz.js.asDynamic()

  addStaticMembersTo(factoryFunc, properties)
  val controllerName = "dropdown"
  println("Registering controller dropdown")

  stimulus.register(controllerName, factoryFunc)
}
